import { Navigate } from 'react-router-dom';
import usePrivateKey from 'hooks/usePrivateKey';

const withAuth = (requiredRight) =>(Component) => {
  return (props) => {
    const { userRights } = usePrivateKey();
    
    if (Object.keys(userRights).length === 0 || !userRights[requiredRight]) { 
      return <Navigate to="/archive/search" replace />;
    }

    return <Component {...props} />;
  };
};

export default withAuth;